import { Component, computed, inject, input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { Location } from '../../../models/classes/location';
import { I18nService } from '../../../services/i18n.service';
import { UiService } from '../../../services/ui.service';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { RenameCardHeaderComponent } from '../../card/rename-card-header/rename-card-header';
import { getIconByEquipmentType } from '../../../utilities/global.util';
import { GLOBAL_CONSTANT } from '../../../constants/global.constant';

@Component({
  selector: 'app-collapse-sidebar',
  imports: [NzCollapseModule, NzIconModule, RouterModule, RenameCardHeaderComponent],
  templateUrl: './collapse-sidebar.html',
  styleUrls: ['./collapse-sidebar.scss'],
})
export class CollapseSidebarComponent {
  getIconByEquipmentType = getIconByEquipmentType;
  private ui = inject(UiService);
  public i18n = inject(I18nService);
  private router = inject(Router);

  selectedSensorId = input<number>(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  selectedAssetId = input<number>(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  location = input<Location | null>(null);

  isMobile = computed(() => this.ui.IsMobile());

  panelExpand = computed(() => {
    const loc = this.location();
    const assetId = this.selectedAssetId();
    if (!loc) return false;

    return loc.Assets.map((a) => a.objectID).includes(assetId);
  });
}
